import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Button as AntButton } from 'antd';

function ButtonContainer({ innerRef, ...props }) {
  return <AntButton type="button" {...props} />;
}

class Button extends Component {
  render() {
    const { ...props } = this.props;
    const Container = props.to ? Link : ButtonContainer;

    return <Container type="button" {...props} />;
  }
}

/**
 * @deprecated
 */
export default styled(withTranslation('ui')(Button))`
  cursor: pointer;
  user-select: none;
  -webkit-touch-callout: none;
`;
